import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';

const webhookUrl = "https://automation.choosecadre.com/api/contacts/QCcuGMu01SbrRK567KtK";
const locationId = "5BkmNNTAJw35aQf0Gb7E";

const ContactForm = () => {
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: '',
        agree: false,
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const [agreeError, setAgreeError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const changeHandler = e => {
        const { name, type, value, checked } = e.target;
        setForms(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
        if (name === "agree" && checked) setAgreeError('');
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        let valid = validator.allValid();
        if (!forms.agree) {
            setAgreeError('You must agree before submitting.');
            valid = false;
        }
        if (valid) {
            validator.hideMessages();
            setAgreeError('');
            setLoading(true);
            setSuccess('');
            setError('');
            try {
                // Split name into first and last
                let [firstName = '', ...rest] = forms.name.trim().split(' ');
                let lastName = rest.join(' ') || '';
                // Fallback if only one name
                if (!lastName) lastName = 'Unknown';
                // Prepare payload
                const payload = {
                    firstName,
                    lastName,
                    name: `${firstName} ${lastName}`.trim(),
                    email: forms.email,
                    locationId,
                    phone: forms.phone,
                    address1: "",
                    city: "",
                    state: "",
                    postalCode: "",
                    country: "US",
                    companyName: forms.subject,
                    tags: ["Contact Form", "Website Inquiry"],
                    source: "Pharmacy Freedom website",
                };
                await axios.post(webhookUrl, payload);
                setSuccess("Form submitted successfully!");
                setForms({
                    name: '',
                    email: '',
                    subject: '',
                    phone: '',
                    message: '',
                    agree: false,
                });
            } catch (err) {
                setError("There was a problem submitting the form.");
            } finally {
                setLoading(false);
            }
        } else {
            validator.showMessages();
        }
    };

    return (
        <form onSubmit={submitHandler} className="contact-validation-active" >
            <div className="row">
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Name" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.phone}
                            type="phone"
                            name="phone"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your phone" />
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <select
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            value={forms.subject}
                            name="subject">
                            <option value="">Select...</option>
                            <option>Investor</option>
                            <option>Pharmacy Owner</option>
                            <option>Healthcare Professional</option>
                            <option>Other</option>
                        </select>
                        {validator.message('subject', forms.subject, 'required')}
                    </div>
                </div>
                <div className="col col-lg-12 col-12">
                    <textarea
                        onBlur={changeHandler}
                        onChange={changeHandler}
                        value={forms.message}
                        name="message"
                        placeholder="Message">
                    </textarea>
                    {validator.message('message', forms.message, 'required')}
                </div>
            </div>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                margin: "28px 0 24px 0"
            }}>
                <input
                    type="checkbox"
                    name="agree"
                    checked={forms.agree}
                    onChange={changeHandler}
                    style={{
                        width: 22,
                        height: 22,
                        accentColor: "#10d876",
                        margin: 0,
                        flexShrink: 0
                    }}
                />
                <span style={{
                    fontSize: 15,
                    color: "#3a3a3a",
                    lineHeight: 1.5
                }}>
                    I agree to receive SMS and email updates about my appointment, as well as notifications and promotional messages. I also accept the Terms &amp; Privacy Policy.
                </span>
            </div>
            {agreeError && <div style={{ color: "red", marginBottom: 12, fontSize: 14 }}>{agreeError}</div>}
            {success && <div style={{ color: "green", marginBottom: 12, fontSize: 14 }}>{success}</div>}
            {error && <div style={{ color: "red", marginBottom: 12, fontSize: 14 }}>{error}</div>}
            <div className="submit-area">
                <button type="submit" className="theme-btn" disabled={loading}>
                    {loading ? "Submitting..." : "Get in Touch"}
                </button>
            </div>
        </form >
    )
}

export default ContactForm;
